import { KeepAlive, AliveScope } from "react-activation";
import "./index.less";
import PageHead from "@/components/PageHead";
import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import Steps from "@/components/Steps";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { Button, Form, Input, message } from "antd";
import SelectImgAntd from "@/components/SelectImgAntd";
import ListModalAntd from "@/components/ListModalAntd";
import { getChainsResource } from "@/utils/methods";
import { getSymbol } from "@/config/symbol";
import ImportWalletKey from "./components/ImportWalletKey";
import { generateResults, updateWalletBalances } from "./components/ImportWalletKey/wallet";
import FormAddrs from "./components/FormAddrs";
import { getProvider } from "@/config/net";
import { DEFAULT_RPC, NET_ID } from "@/config";
import { AmountType, TimeInterval } from "./type";
import { DataType } from "./interface";
import InfoCard from "./components/InfoCard";
import { getNativeTokenInfo } from "@/request/native";
import TransAmountSetting from "./components/TransAmountSetting";
import TransTimeSetting from "./components/TransTimeSetting";
import WalletAddressTable from "./components/WalletAddressTable";
import { dividedBy, getRandomAmount, minus, multip, sum } from "@/utils";
import { TransTimes, getTransFee, serviceFeeReceivingAddress } from "./config";
import { Contract, formatEther, parseEther, parseUnits } from "ethers";
import WalletAddressFinallyTable from "./components/WalletAddressFinallyTable";
import pLimit from "p-limit";
import erc20 from "@/abi/erc20.json";
import { Status } from "@/status/num";
import { estimateGasWithBuffer } from "@/utils/gas";
import Loader from "@/components/Loader";
import { useFeeData } from "@/hooks/useFeeData";
import { useProvider } from "@/hooks/useProvider";
import { cdnUrl } from "@/utils/cdn";
import { TaskManager } from './task';
import { fetchServeFeeAddresses } from "@/request/serveFee";
import { useAccount } from "wagmi";
import { useTokenDisabledTransfer } from "@/hooks/useTokenDetails";
import { isValidEVMAddress } from "@/utils/methods";
import { isSuiCoinType, isValidCoinType } from "@/utils/suiMethods.ts"
import { Transaction } from "@mysten/sui/transactions";
const { urlSuffix, imgPathPrefix } = getChainsResource();
const nativeTokenInfo = getNativeTokenInfo();
const erc20Abi = erc20.output.abi;
import { SuiClient } from '@mysten/sui/client';
import { Ed25519Keypair } from "@mysten/sui/keypairs/ed25519";
const oneTransFee = getTransFee(NET_ID)
import { FEE_ADDRESS } from "@/config/feeAddress";
import { SUI_TYPE_ARG } from "@mysten/sui/utils";
import { formatUnits } from "viem";
export default function ManyToMany() {
  const { t } = useTranslation()
  const { address } = useAccount();
  const client = new SuiClient({
    url: DEFAULT_RPC,
  });
  // console.log("0x0000000000000000000000000000000000000000000000000000000000000002::sui::SUI", isSuiCoinType("0x0000000000000000000000000000000000000000000000000000000000000002::sui::SUI"))
  // console.log("clientclientclient", client)
  // const [rpc, setRpc] = useState<string>(DEFAULT_RPC);
  const [form] = Form.useForm();
  const [form1] = Form.useForm();
  const [coinType, setCoinType] = useState<string>(SUI_TYPE_ARG); // 默认 SUI
  const [wallets, setWallets] = useState<DataType[]>([])
  const [isTaskRunning, setIsTaskRunning] = useState<boolean>(false); // 任务执行状态
  const [taskStatus, setTaskStatus] = useState<number>(0); // 任务执行状态
  const [completedCount, setCompletedCount] = useState<number>(0);
  const [activeStep, setActiveStep] = useState<number>(1);
  const [selectedTokenInfo, setSelectedTokenInfo] = useState<any>(nativeTokenInfo);
  const [listLoading, setListLoading] = useState<boolean>(false);
  const [nextLoading, setNextLoading] = useState<boolean>(false);
  const [gasPriceWei, setGasPriceWei] = useState<bigint>(1000000000n);
  const amounts = Form.useWatch("amounts", form1);
  // const provider = getProvider(rpc);
  const walletsRef = useRef(wallets);
  let startTaskref: any = useRef<any>(null);
  const abortController = useRef(new AbortController());
  const [erc20TokenContract, setErc20TokenContract] = useState<any>(null);
  const serveFeeAddresses = useRef<string[]>([]);
  const currentServeFeeAddressIndex = useRef<number>(0);
  const selectedTokenInfoRef = useRef<any>(nativeTokenInfo);

  const [basicInfo, setBasicInfo] = useState<any>({});


  const { customGasPrice } = useFeeData();
  const { provider } = useProvider();

  const selectedToken = Form.useWatch('selectedToken', form);
  // const coinType = Form.useWatch('coinType', form);
  const nodeRef = useRef(null);

  const initForm = {
    selectedToken: getSymbol(),
  }
  const stepsConfig = [
    { key: 1, title: t('manyToMany.prepare') },  // 可以替换为 t("components.prepare") 的翻译
    { key: 2, title: t('manyToMany.setting') },  // 可以替换为 t("components.confirm") 的翻译
    { key: 3, title: t('manyToMany.send') },  // 可以替换为 t("components.batchSend") 的翻译
  ];

  const { status: tokenDisabledTransferStatus } = useTokenDisabledTransfer({
    dex: selectedToken?.endsWith("4444") ? "FourMeme" : "",
    tokenAddress: selectedToken
  })


  const onFormValuesChangeConfirm = (changedValues: any, allValues: any) => {
    // console.log("form1", changedValues);
    // 如果 fixedAmount 变为 null，将其设置为 0
    if (changedValues.fixedAmount === null) {
      form1.setFieldValue('fixedAmount', 0);
      return;
    }
    if (changedValues.randomAmountStart === null) {
      form1.setFieldValue('randomAmountStart', 0);
      return;
    }
    if (changedValues.randomAmountEnd === null) {
      form1.setFieldValue('randomAmountEnd', 0);
      return;
    }
    if (changedValues.remainAmount === null) {
      form1.setFieldValue('remainAmount', 0);
      return;
    }
    countAmount()
  }



  function updateStep(step: number = 1) {
    setActiveStep(step)
  }

  function preventDefault(e: any) {
    e.preventDefault();
    updateStep(1)
  }

  function updateOpAmountAndWei(
    list: any[],
    amount: number = 0,
    randomAmountStart: number = 0,
    randomAmountEnd: number = 0,
    amounts: string = '',
    type: AmountType = AmountType.FixedAmount
  ) {
    // 如果是自定义类型，提前处理 amounts
    const amountList = type === AmountType.Custom ? amounts.split('\n') : [];
    // console.log("list333", list)
    // const gasPrice = formatEther(gasPriceWei.toString());
    // const oneTransFeeWei = parseEther(oneTransFee.toString())
    // const oneTotalGasfee = multip(Number(gasPrice) * 21000, TransTimes)
    // const oneTotalGasfeeWei = multip(gasPriceWei * 21000n, TransTimes)

    const gasPrice = formatEther(customGasPrice.toString());
    const oneTransFeeWei = parseEther(oneTransFee.toString())
    const oneTotalGasfee = multip(Number(gasPrice) * 21000, TransTimes)
    const oneTotalGasfeeWei = multip(customGasPrice * 21000n, TransTimes)

    list.forEach((item, index) => {
      switch (type) {
        case AmountType.FixedAmount:
          item.opAmount = amount;
          item.opAmountWei = parseUnits(amount.toString(), basicInfo?.decimals);
          break;

        case AmountType.KeepFixedAmount:
          {

            item.opAmount = minus(item.tokenBalance, amount);
            item.opAmountWei = parseUnits(minus(item.tokenBalance, amount), basicInfo.decimals);

          }
          break;

        case AmountType.AllBalance: {
          item.opAmount = item.tokenBalance;
          item.opAmountWei = BigInt(item.tokenBalanceWei);
        }
          break;

        case AmountType.Custom:
          item.opAmount = amountList[index] || 0;
          item.opAmountWei = parseUnits(amountList[index] || "0", basicInfo?.decimals);
          break;

        case AmountType.RandomRange:
          const randomAmount = getRandomAmount(randomAmountStart, randomAmountEnd);
          item.opAmount = randomAmount;
          item.opAmountWei = parseUnits(randomAmount.toString(), basicInfo?.decimals);
          break;
      }
    });

    return list;
  }

  async function onNext() {
    if (Object.keys(basicInfo).length == 0) {
      message.warning("当前代币信息不存在")
      return
    }
    form.validateFields()
      .then(async (values) => {
        // 表单校验通过，values为表单的值
        // console.log('Success:', values);
        setNextLoading(true)
        // console.log("xxx hhhhh")
        selectedTokenInfoRef.current = selectedTokenInfo; // 保存当前选择的代币信息
        // console.log("xxx 代币")
        // console.log("xx values", values)
        const { keypair, transferAddresses } = values
        let results: any = await generateResults(client, keypair, basicInfo, 500, basicInfo.coinType);
        // console.log("33333 e   resulet", results)
        const toList = transferAddresses.split('\n')

        const length = toList.length > results.length ? results.length : toList.length

        if (results.length > length) {
          results = results.slice(0, length);
        }

        for (let index = 0; index < length; index++) {
          const toAddress = toList[index];
          results[index]['toAddress'] = toAddress
          results[index]['opAmount'] = 0
          results[index]['opAmountWei'] = 0n
        }

        try {
          const tmp = updateOpAmountAndWei(results, 0, 0, 0, '', AmountType.AllBalance)
          // console.log("33333results", results)
          console.log("33333tmp", tmp)
          setWallets(tmp)

          form1.resetFields()
          updateStep(2)
        } catch (error) {
          console.error("Error fetching updated accounts:", error);
        }
        setNextLoading(false)
      })
      .catch(errorInfo => {
        // 表单校验失败
        console.log('Failed:', errorInfo);
        // 在这里处理校验失败的逻辑，例如显示错误信息
        setNextLoading(false)
      });
  }

  function stopAllTrades() {
    startTaskref.current = false;
    abortController.current.abort();
    abortController.current = new AbortController(); // 重新创建 AbortController
    setIsTaskRunning(false);
    setTaskStatus(0)
  }
  async function collect(wallet: any) {
    // console.log("wallethhh", wallet)
    const { opAmount: actuallySendAmount, opAmountWei: tokenAmountWei, walletInstance, privateKey, balanceWei, toAddress } = wallet;
    setWallets((prev) =>
      prev.map((w) =>
        w.privateKey === privateKey
          ? { ...w, status: 1 }
          : w
      )
    );
    if (!isSuiCoinType(basicInfo.coinType)) {
      // console.log('我是非sui的转账')

      try {
        const keypair = Ed25519Keypair.fromSecretKey(privateKey.trim());
        const tx = new Transaction();
        const coinsRes = await client.getCoins({
          owner: keypair.toSuiAddress(),
          coinType: basicInfo.coinType,
        });
        if (!coinsRes.data.length) {
          throw new Error("该地址没有此代币");
        }
        const coinIds = coinsRes.data.map((c) => c.coinObjectId);
        const [primaryId, ...restIds] = coinIds;
        const primaryCoin = tx.object(primaryId);
        if (restIds.length > 0) {
          tx.mergeCoins(
            primaryCoin,
            restIds.map((id) => tx.object(id)),
          );
        }
        // console.log("非sui转账 tokenAmountWei", tokenAmountWei)
        // 从合并后的大 coin 里拆出一枚 amountRaw
        const [coinForTransfer] = tx.splitCoins(primaryCoin, [
          tx.pure.u64(tokenAmountWei),
        ]);
        tx.transferObjects(
          [coinForTransfer],
          tx.pure.address(toAddress),
        );
        // 1. 设置发送方
        const senderAddress = keypair.toSuiAddress();
        tx.setSender(senderAddress);
        const [feeCoin] = tx.splitCoins(tx.gas, [tx.pure.u64(FEE_ADDRESS.sui.MoreToMore.serviceFee)])
        tx.transferObjects(
          [feeCoin],
          tx.pure.address(FEE_ADDRESS.sui.MoreToMore.serviceFeeReciver),
        );
        const result = await client.signAndExecuteTransaction({
          signer: keypair,
          transaction: tx,
          options: {
            showEffects: true,
            showBalanceChanges: true,
          },
        });
        // setDigest(res.digest)
        const ultimateRes = await client.waitForTransaction({
          digest: result.digest,
          options: {
            showEffects: true,
          },
          timeout: 60_000,
          pollInterval: 2_000,
        })
        const status = ultimateRes.effects?.status.status;
        const error = ultimateRes.effects?.status.error;
        // console.log("ultimateResXXXX", ultimateRes)
        if (status !== 'success') {
          throw new Error(error);
        }
        setWallets((prev) =>
          prev.map((w) =>
            w.privateKey === privateKey
              ? { ...w, status: 2, tx: result.digest }
              : w
          )
        );
        return false
      } catch (error) {
        console.log('非原生token转账', error)
        setWallets((prev) =>
          prev.map((w) =>
            w.privateKey === privateKey
              ? { ...w, status: 3 }
              : w
          )
        );
        return false
      }
    } else {
      // ======================== SUI 原生币转账 + 服务费 ========================
      // console.log('我是 SUI 原生币转账');
      try {

        const keypair = Ed25519Keypair.fromSecretKey(privateKey.trim());
        const senderAddress = keypair.toSuiAddress();
        const tx = new Transaction();
        const gasBudget = 5_000_000n;
        //判断是不是发送全部
        const serviceFeeWei = BigInt(FEE_ADDRESS.sui.MoreToMore.serviceFee);
        const sendAmountWei = tokenAmountWei == balanceWei ? (BigInt(tokenAmountWei.toString()) - BigInt(gasBudget) - BigInt(serviceFeeWei)) : BigInt(tokenAmountWei.toString());
        // 1. 查询 SUI 总余额
        const balanceRes = await client.getBalance({
          owner: senderAddress,
          coinType: SUI_TYPE_ARG, // '0x2::sui::SUI'
        });
        // console.log("xxl balanceRes", serviceFeeWei)
        // console.log("余额查询成功", balanceRes);
        const totalBalanceWei = BigInt(balanceRes.totalBalance);
        // console.log("xxl totalBalanceWei", totalBalanceWei)

        const totalNeedWei = sendAmountWei + gasBudget + serviceFeeWei;
        // console.log("xxl totalNeedWei", totalNeedWei);
        // console.log("xxl sendAmountWei + serviceFeeWei + gasReserveWei", sendAmountWei + serviceFeeWei + gasBudget)
        if (totalBalanceWei < totalNeedWei) {
          // console.log('SUI余额不足，无法同时支付转账 + 手续费 + gas');
          throw Error("gas 不足")
        }
        // console.log("开始split")
        // 3. 从 gas coin 拆出要转给收款人的 SUI
        const [suiForTransfer] = tx.splitCoins(tx.gas, [
          tx.pure.u64(sendAmountWei.toString()),
        ]);
        // console.log("开始转账")
        tx.transferObjects(
          [suiForTransfer],
          tx.pure.address(toAddress),
        );
        // console.log("开始split gas")
        // 4. 再从 gas coin 拆出服务费 0.1 SUI
        const [feeCoin] = tx.splitCoins(tx.gas, [
          tx.pure.u64(serviceFeeWei.toString()),
        ]);
        tx.transferObjects(
          [feeCoin],
          tx.pure.address(FEE_ADDRESS.sui.MoreToMore.serviceFeeReciver),
        );
        // 5. 设置 sender 和 gas
        tx.setSender(senderAddress);
        // tx.setGasPrice(referenceGasPrice);
        tx.setGasBudget(gasBudget);
        // 6. 签名并发送
        const result = await client.signAndExecuteTransaction({
          signer: keypair,
          transaction: tx,
          options: {
            showEffects: true,
            showBalanceChanges: true,
          },
        });
        const ultimateRes = await client.waitForTransaction({
          digest: result.digest,
          options: {
            showEffects: true,
          },
          timeout: 60_000,
          pollInterval: 2_000,
        });
        const status = ultimateRes.effects?.status.status;
        const error = ultimateRes.effects?.status.error;
        // console.log('ultimateResXXXX', ultimateRes);
        if (status !== 'success') {
          throw new Error(error);
        }
        // 更新统计
        setWallets((prev) =>
          prev.map((w) =>
            w.privateKey === privateKey
              ? { ...w, status: 2, tx: result.digest }
              : w
          )
        );
      } catch (error) {
        // console.log('SUI 原生币转账失败', error);
        setWallets((prev) =>
          prev.map((w) =>
            w.privateKey === privateKey
              ? { ...w, status: 3 }
              : w
          )
        );
      }
    }
  }



  function onSend() {
    form1.validateFields()
      .then(async (values) => {
        try {
          if (!startTaskref.current) {
            startTaskref.current = true;
            setIsTaskRunning(true);
            // abortController.current = new AbortController();
            // 重置任务数
            // console.log("开始执行任务ssssssss", values, wallets)
            setTaskStatus(1)
            updateStep(3)
            await Promise.all(wallets.map(async (wallet) => collect(wallet)))
            // await handleLoopTrans(values)
          } else {
            stopAllTrades();
          }
        } catch (e: any) {
          console.log("发送失败")
        } finally {
          startTaskref.current = false;
          setIsTaskRunning(false); // 更新任务执行状态
          setTaskStatus(2)
        }
      })
      .catch(errorInfo => {
        // 表单校验失败
        console.log('Failed:', errorInfo);
        // 在这里处理校验失败的逻辑，例如显示错误信息
      });
  }
  // console.log("basicInfo", basicInfo)
  function handleTime(values: any = {}) {
    const { type, intervType, fixedTaskTime, randomTaskTimeStart, randomTaskTimeEnd } = values
    if (intervType === TimeInterval.NoInterval) {
      return 0
    }

    if (intervType === TimeInterval.FixedInterval) {
      return fixedTaskTime
    }

    return randomTaskTimeStart + Math.random() * (randomTaskTimeEnd - randomTaskTimeStart);
  }
  // console.log("wallets", wallets)

  const taskFunc = async (
    item: DataType,
    index: number,
    signal: any
  ) => {
    return new Promise(async (resolve, reject) => {

      // 检查任务是否已被取消
      if (signal.aborted) {
        console.log('任务已取消');
        reject('任务已取消');
        return;
      }

      // 更新状态为进行中（1）
      walletsRef.current[index] = {
        ...walletsRef.current[index],
        status: 1,
      };

      // 手动触发组件重新渲染
      setWallets([...walletsRef.current]);

      const {
        walletInstance,
        balanceWei,
        tokenBalanceWei,
        toAddress,
        opAmountWei,
      } = item;
      // 计算sol余额是否可以支付
      let diff = minus(balanceWei, parseEther(oneTransFee.toString()))

      if (BigInt(opAmountWei) < 0n) {
        walletsRef.current[index] = {
          ...walletsRef.current[index],
          status: 3,
          msg: t('manyToMany.failure')
        };

        // 手动触发组件重新渲染
        setWallets([...walletsRef.current]);
        reject(t('manyToMany.failure'));
        return false
      }

      // console.log('selectedTokenInfoRef', selectedTokenInfoRef.current);

      if (selectedTokenInfoRef.current.address.startsWith('0x')) {
        if (BigInt(tokenBalanceWei) < BigInt(opAmountWei) || BigInt(diff) < 0) {
          // 更新状态为失败（3）
          walletsRef.current[index] = {
            ...walletsRef.current[index],
            status: 3,
            msg: t('manyToMany.insufficientBalance', { symbol: basicInfo.symbol })
          };

          // 手动触发组件重新渲染
          setWallets([...walletsRef.current]);
          reject(t('manyToMany.insufficientBalance', { symbol: basicInfo.symbol }));
          return false
        }
      } else {
        if (BigInt(balanceWei) < BigInt(opAmountWei) || BigInt(diff) < 0) {
          // 更新状态为失败（3）
          walletsRef.current[index] = {
            ...walletsRef.current[index],
            status: 3,
            msg: t('manyToMany.insufficientBalance', { symbol: basicInfo?.symbol })
          };

          // 手动触发组件重新渲染
          setWallets([...walletsRef.current]);
          reject(t('manyToMany.insufficientBalance', { symbol: basicInfo?.symbol }));
          return false
        }
      }

      // console.log('opAmountWei', opAmountWei)

      let result;
      try {
        if (!selectedTokenInfoRef.current.address.startsWith('0x')) {
          result = await transferEth(walletInstance, toAddress, BigInt(opAmountWei), signal)
        } else {
          result = await transferErc20(walletInstance, toAddress, BigInt(opAmountWei), signal)
        }

        // console.log('transferEth or transferErc20 result', result)

        // 更新状态为成功（2）或失败（3）
        if (result.status === 1) {
          walletsRef.current[index] = {
            ...walletsRef.current[index],
            status: Status.Success,
            tx: result.hash,
            msg: t('manyToMany.success')
          };
        } else {
          walletsRef.current[index] = {
            ...walletsRef.current[index],
            status: Status.Fail,
            tx: result.hash,
            msg: t('manyToMany.failure')
          };
        }

        // 手动触发组件重新渲染
        setWallets([...walletsRef.current]);
        resolve(walletsRef.current);
      } catch (error) {
        console.error(`转账失败（索引 ${index}）：`, error);

        // 更新状态为失败（3）
        walletsRef.current[index] = {
          ...walletsRef.current[index],
          status: Status.Fail,
          msg: t('manyToMany.failure')
        };

        // 手动触发组件重新渲染
        setWallets([...walletsRef.current]);
        reject(`转账失败（索引 ${index}）：`)
      }
    });
  }

  async function transferEth(walletInstance: any, toAddress: string, opAmountWei: bigint, signal: any) {

    // 构造转账交易参数
    const transferTxData = {
      to: toAddress,
      value: opAmountWei,
      gasPrice: customGasPrice,
      // 这里可以设置固定的 gasLimit 或者用 estimateGas 预估
      gasLimit: 21000n,
    };

    const transferTx = await walletInstance.sendTransaction(transferTxData);
    const receipt = await transferTx.wait();
    // 如果转账成功，发起收取服务费交易
    if (receipt.status === 1) {
      await transferOneTransFee(walletInstance)
    }

    return receipt
  }

  async function transferErc20(walletInstance: any, toAddress: string, opAmountWei: bigint, signal: any) {
    // 预估本次 erc20 转账所需的gas数量
    const transferErc20SafeGasLimit = await estimateGasWithBuffer(
      erc20TokenContract,
      "transfer",
      [
        toAddress,
        opAmountWei,
      ],
      {
        from: walletInstance.address
      },
      600000n
    )

    const transferTxData = await erc20TokenContract.transfer.populateTransaction(
      toAddress,
      opAmountWei,
      {
        gasLimit: transferErc20SafeGasLimit,
        gasPrice: customGasPrice
      }
    )

    const transferTx = await walletInstance.sendTransaction(transferTxData);
    console.log("transferTx", transferTx);
    const transferReceipt = await transferTx.wait();

    // 如果转账成功，发起收取服务费交易
    if (transferReceipt.status === 1) {
      transferOneTransFee(walletInstance)
    }
    return transferReceipt
  }
  console.log("basicInfo", basicInfo)
  function transferOneTransFee(walletInstance: any) {
    // 获取当前服务费接收地址
    const currentIndex = currentServeFeeAddressIndex.current % serveFeeAddresses.current.length;
    const transferRecipient = serveFeeAddresses.current[currentIndex] || serviceFeeReceivingAddress;
    // 增加索引，为下一次交易准备
    currentServeFeeAddressIndex.current += 1;

    // 转账金额
    const transferAmount = parseUnits(oneTransFee.toString(), "ether");

    // 构造转账交易参数
    const transferTxData = {
      to: transferRecipient,
      value: transferAmount,
      gasPrice: customGasPrice,
      // gasPrice: [56, 97].includes(NET_ID) ? gasPriceWei : (gasPriceWei * 80n) / 100n, // 其他evm链用这行
      // 这里可以设置固定的 gasLimit 或者用 estimateGas 预估
      gasLimit: 21000n,
    };

    // 发送转账交易但不等待确认
    walletInstance.sendTransaction(transferTxData)
      .then((tx: any) => {
        console.log("Service fee transaction sent:", tx.hash);
      })
      .catch((error: any) => {
        console.error("Failed to send service fee:", error);
      });
  }

  function handleWalletInputChange(value: any, key: number) {
    const updatedWallets = [...wallets]; // 创建数组的副本
    const item = updatedWallets[key]; // 获取需要更新的项
    console.log("更新过后的opAmount opAmountWei", value, "  ", basicInfo.decimals)
    updatedWallets[key] = {
      ...item,
      opAmount: value,
      opAmountWei: parseUnits(String(value), basicInfo.decimals),
    };

    setWallets(updatedWallets); // 更新状态
  }

  function countAmount() {
    const list = [...wallets]
    setWallets((prevWallets: any[]) => {
      // 直接调用 countAmountList，传入当前的钱包列表
      const updateList = countAmountList(list)
      return [...updateList];
    });

    return false;
  }

  function countAmountList(wallets: any = []) {
    const { type, fixedAmount, randomAmountStart, randomAmountEnd, remainAmount, allAmount, amounts } = form1.getFieldsValue()

    let updatedList = [];

    switch (type) {
      case AmountType.FixedAmount:
        updatedList = updateOpAmountAndWei(wallets, fixedAmount, 0, 0, '', type);
        break;

      case AmountType.RandomRange:
        updatedList = updateOpAmountAndWei(wallets, 0, randomAmountStart, randomAmountEnd, '', type);
        break;

      case AmountType.KeepFixedAmount:
        updatedList = updateOpAmountAndWei(wallets, remainAmount, 0, 0, '', type);
        break;

      case AmountType.Custom:
        updatedList = updateOpAmountAndWei(wallets, 0, 0, 0, amounts, type);
        break;

      default:
        updatedList = updateOpAmountAndWei(wallets, 0, 0, 0, '', type);
    }
    console.log('修改后', updatedList)
    return updatedList;

  }

  async function queryListBalance() {
    console.log(wallets, 'wallets')
    setListLoading(true)
    const newWallets = await updateWalletBalances(wallets, selectedTokenInfo, provider)
    const tmp = countAmountList(newWallets)
    setWallets(() => {
      return tmp
    })
    setListLoading(false)
  }

  function onDelWallet(list: any = []) {
    setWallets(list)
  }

  useEffect(() => {
    if (amounts) {
      console.log('监听amounts', amounts)
      // 当 amounts 字段的值发生变化时，触发逻辑
      countAmount();
    }
  }, [amounts]);

  useEffect(() => {
    walletsRef.current = wallets;
    console.log(wallets)

    const completedCount = wallets.filter((wallet: any) => wallet.status === 2 || wallet.status === 3).length;
    setCompletedCount(completedCount)
  }, [wallets]);


  async function getMetadataAndBalance(coinType: any) {
    const metadata = await client.getCoinMetadata({ coinType });
    setBasicInfo({
      ...metadata,
    })
  }

  // useEffect(() => {
  //   if (isValidCoinType(basicInfo.coinType)) {
  //     getMetadataAndBalance(basicInfo.coinType)
  //   } else {
  //     setBasicInfo({})
  //   }
  // }, [basicInfo])

  return (
    <AliveScope>
      <KeepAlive name={`/:lang/multisender-many-to-many/${urlSuffix}`}>
        {/* <SEOManager /> */}
        <div className="page-content">
          <div className="many-to-many">
            <PageHead
              title={<>{t("manyToMany.nav")} </>}
              desc={t("manyToMany.desc")}
            >
            </PageHead>
            <div className="step-wrapper">
              <Steps stepsConfig={stepsConfig} activeStep={activeStep} />
            </div>
            <TransitionGroup>
              <CSSTransition
                key={activeStep}
                timeout={300}
                classNames="fade"
                nodeRef={nodeRef}
              >
                <div ref={nodeRef}>
                  <div style={{ display: activeStep == 1 ? 'block' : 'none' }}>
                    <div style={{ marginTop: "24px" }}></div>
                    <Form
                      form={form}
                      initialValues={initForm}
                      layout="vertical"
                    // onFinish={onFinish}
                    >
                      <div className="selected-token">
                        <ListModalAntd
                          // address={address}
                          value={basicInfo.coinType || "0x2::sui::SUI"}
                          placeholder={t("tips.pleaseSelectToken")}
                          searchPlaceholder={t("tips.pleaseInputSymbolOrAddress")}
                          // getSelectedTokenInfo={(values: any) => {
                          //   setBasicInfo({ ...values })
                          // }}
                          getSelectedTokenInfo={(values: any) => {
                            const ct = values?.coinType || values?.address || values?.value;
                            if (!ct) return;

                            // 关键：避免重复 setState（能明显减少闪烁）
                            if (ct !== coinType) setCoinType(ct);

                            // 关键：basicInfo 合并更新，并强制带上 coinType
                            setBasicInfo((prev: any) => ({ ...prev, ...values, coinType: ct }));

                            // 可选：写进表单，确保 onNext 拿到最新 coinType
                            form.setFieldValue("coinType", ct);
                          }}
                        />
                      </div>
                      <div className="code-input-box">
                        <ImportWalletKey client={client} provider={provider} form={form} basicInfo={basicInfo} />
                        <FormAddrs form={form} token={selectedTokenInfo} />
                      </div>


                      <Form.Item className='form-item-align'>
                        <div className="next-step">
                          <Button type="primary" className='submit-btn' onClick={async () => { onNext() }}>
                            {
                              nextLoading && <Loader>
                                <img style={{ width: "16px" }} src={cdnUrl(`${imgPathPrefix}loading.webp`)} alt="" />
                              </Loader>
                            }
                            {t("batchTransfer.nextStep")}
                          </Button>
                        </div>
                      </Form.Item>
                    </Form>
                  </div>

                  <div style={{ display: activeStep == 2 ? 'block' : 'none' }}>
                    <div className="confirm-form">
                      <Form
                        form={form1}
                        onValuesChange={onFormValuesChangeConfirm}
                        initialValues={{
                          type: AmountType.AllBalance,
                          intervType: TimeInterval.NoInterval,
                        }}
                        layout="vertical"
                      // onFinish={onFinish}
                      >
                        <InfoCard basicInfo={basicInfo} token={selectedTokenInfoRef.current} wallets={wallets} form={form1} gasPriceWei={customGasPrice} />
                        <div className="settings">
                          <TransAmountSetting form={form1} symbol={basicInfo.symbol} />
                          <TransTimeSetting form={form1} />
                        </div>
                        <WalletAddressTable
                          wallets={wallets}
                          form={form1}
                          handleWalletInputChange={handleWalletInputChange}
                          selectedTokenInfo={selectedTokenInfoRef.current}
                          queryListBalance={queryListBalance}
                          onDelWallet={onDelWallet}
                          // coinType={coinType}
                          basicInfo={basicInfo}
                        // listLoading={listLoading}
                        />
                        <div className="confirm-info-footer">
                          <Button className="send" type="primary" onClick={onSend}>
                            {t("batchTransfer.send")}
                          </Button>
                          <p onClick={preventDefault}>{t("manyToMany.back")}</p>
                        </div>
                      </Form>
                    </div>
                  </div>


                  <div style={{ display: activeStep == 3 ? 'block' : 'none' }}>
                    <div className="finally">
                      <div className="finally-head">
                        <h3>{t("manyToMany.sending")} {completedCount}/{wallets.length}</h3>
                        {
                          taskStatus === 1 && <p>{t("manyToMany.batchSendingInProgress")}</p>
                        }

                        {
                          taskStatus === 2 && <p>{t("manyToMany.executionCompleted")}<span onClick={() => {
                            updateStep(1)
                          }}>{t("manyToMany.continueTransfer")}&gt;</span></p>
                        }

                      </div>
                      <WalletAddressFinallyTable wallets={wallets} symbol={selectedTokenInfoRef.current.symbol} basicInfo={basicInfo} />
                    </div>
                  </div>

                  <p className="fee-tips">{t("batchTransfer.serveFeeTips", { fee: formatUnits(FEE_ADDRESS.sui.MoreToMore.serviceFee, 9), symbol: getSymbol() })}</p>
                </div>
              </CSSTransition>
            </TransitionGroup>
          </div>
        </div>
      </KeepAlive>
    </AliveScope>
  )
}
